export const signupConfirmationPath = "/auth/confirm";
export const passwordResetPath = "/auth/reset-password";
// One-shot flag: signing out after a reset resets navigation to /login, which then confirms the change.
export const passwordUpdatedNoticeKey = "froppio:password-updated";
